module.exports = __webpack_public_path__ + "media/images/auth/lockscreen-bg-5f5074b5d05fd6cd07f5eb4269be67a1.jpg";